import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client, ClientType, ClientStatus, PersonType } from '../../models/client';
import { ImmobilierService } from '../../services/immobilier.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-add-edit-client-dialog',
    templateUrl: './add-edit-client-dialog.component.html',
    styleUrls: ['./add-edit-client-dialog.component.css']
})
export class AddEditClientDialogComponent implements OnInit {

    client: Client;
    isNew: boolean = true;

    // Dropdown options
    clientTypes: ClientType[] = ['prospect', 'client', 'proprietaire', 'locataire', 'acheteur'];
    personTypes: PersonType[] = ['physique', 'morale'];
    clientStatuses: ClientStatus[] = ['actif', 'inactif', 'bloque', 'archived', 'douteux', 'en_contentieux'];
    interestLevels: string[] = ['faible', 'moyen', 'eleve'];
    sources: string[] = ['Agence', 'Site web', 'Recommandation', 'Reseaux sociaux', 'Autre'];

    // Nouveaux dropdowns KYC
    maritalStatuses: string[] = ['Célibataire', 'Marié(e)', 'Veuf(ve)', 'Divorcé(e)'];
    matrimonialRegimes: string[] = ['Séparation', 'Communautaire', 'Autre'];
    paymentMethods: string[] = ['Espèces', 'Chèque', 'Virement'];

    // Custom Stepper
    currentStep = 0;
    steps: string[] = [
        'Identité & Contact',
        'Coordonnées',
        'Informations KYC',
        'Conjoint(e)',
        'Suivi Commercial',
        'Documents'
    ];

    constructor(
        public dialogRef: MatDialogRef<AddEditClientDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private immobilierService: ImmobilierService,
        private snackBar: MatSnackBar
    ) {
        if (data && data.client) {
            this.client = { ...data.client };
            this.isNew = false;
        } else {
            this.isNew = true;
            this.client = {
                id: 0,
                type: 'prospect',
                personType: 'physique',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                status: 'actif',
                createdAt: new Date(),
                updatedAt: new Date()
            };
        }
    }

    ngOnInit(): void {
    }

    // Stepper Navigation
    nextStep(): void {
        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
        }
    }

    prevStep(): void {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
    }

    setStep(index: number): void {
        this.currentStep = index;
    }

    // Actions
    save(): void {
        // Basic validation
        if (!this.client.firstName || !this.client.lastName) {
            this.snackBar.open('Veuillez remplir les champs obligatoires (Nom, Prénom)', 'Fermer', { duration: 3000 });
            return;
        }

        if (this.isNew) {
            this.immobilierService.createClient(this.client).subscribe({
                next: (res) => {
                    this.snackBar.open('Client créé avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de la création du client', 'Fermer', { duration: 3000 });
                }
            });
        } else {
            this.immobilierService.updateClient(this.client.id, this.client).subscribe({
                next: (res) => {
                    this.snackBar.open('Client mis à jour avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de la mise à jour du client', 'Fermer', { duration: 3000 });
                }
            });
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }

    // Document Management
    onFileSelected(event: any, type: string): void {
        const file = event.target.files[0];
        if (file) {
            this.addDocument(file, type);
        }
    }

    addDocument(file: File, type: string): void {
        if (!this.client.documents) {
            this.client.documents = [];
        }
        const newDoc = {
            id: Date.now(),
            type: type,
            name: file.name,
            url: file.name, // Simulating upload
            uploadDate: new Date()
        };
        this.client.documents.push(newDoc);
    }

    removeDocument(index: number): void {
        if (this.client.documents) {
            this.client.documents.splice(index, 1);
        }
    }
}
